import { SidebarTab } from 'components';
import ExamIcon from 'components/assets/svg/sidebar/exams.svg';
import AcIcon from 'components/assets/svg/sidebar/cok.svg';
import MemberIcon from 'components/assets/svg/sidebar/experts.svg';
import { ExpertStatus } from '../api/ApiClient';

const sidebarTabs: SidebarTab[] = [
    /*{
        name: 'Аккредитации',
        icon: ExamIcon,
        state: 'exams',
        list: [
            {
                name: 'Список аккредитаций',
                path: '/exam-list',
                routes: ['/exam/*?from=exam-list'],
                role: [ExpertStatus.AcSecretary, ExpertStatus.AscChairman, ExpertStatus.AcChairman, ExpertStatus.AscMember],
            },
            {
                name: 'Запросы на проведение',
                path: '/conduct-requests',
                routes: ['/exam/*?from=conduct-requests'],
                role: [ExpertStatus.AscChairman, ExpertStatus.AcSecretary],
            },
            {
                name: 'Список аккредитуемых',
                path: '/applicants',
                routes: ['/applicant-details/*'],
                role: [ExpertStatus.AscChairman, ExpertStatus.AcChairman, ExpertStatus.AcSecretary],
            },
        ],
    },*/
    {
        name: 'Управление АПК',
        icon: AcIcon,
        state: 'asc',
        role: [ExpertStatus.AscChairman],
        list: [
            {
                name: 'Члены АПК',
                path: '/experts',
                role: [ExpertStatus.AscChairman],
            },
            {
                name: 'Запросы на изменение',
                path: '/change-requests',
                role: [ExpertStatus.AscChairman],
            },
            {
                name: 'Список АЦ',
                path: '/accreditation-centers',
                routes: ['/accreditation-center-details/*?from=ac-list'],
                role: [ExpertStatus.AscChairman],
            },
        ],
    },
    {
        name: 'Управление АК',
        icon: AcIcon,
        state: 'ac',
        role: [ExpertStatus.AcChairman, ExpertStatus.AcSecretary],
        list: [
            {
                name: 'Список АПК',
                path: '/asc',
            },
            {
                name: 'Список членов АК',
                path: '/experts',
            },
            {
                name: 'Запросы на изменение',
                path: '/change-requests',
            },
            {
                name: 'Список АЦ',
                path: '/accreditation-centers',
            },
            {
                name: 'Информация по АК',
                path: '/ac-details',
            },
        ],
    },
    {
        name: 'Комиссии',
        icon: MemberIcon,
        state: 'asc',
        role: [ExpertStatus.AscMember],
        list: [
            {
                name: 'Участие в АПК',
                path: '/asc-participate',
                role: [ExpertStatus.AscMember],
            },
            {
                name: 'История назначений',
                path: '/assignment-history',
                role: [ExpertStatus.AscMember],
            },
        ],
    },
];

export default sidebarTabs;
